import { Directive, effect, inject, input, signal } from '@angular/core'

import { TemplateConfigInterface, fonts, theme } from '@flowx/core-sdk'
import {
  CardStyles,
  ContainerStyles,
  FormStyles,
  applyContainerCustomStyles,
} from '@flowx/core-theme'

import { ComponentType } from '../injectors'

@Directive({
  selector:
    '[flxLayoutContainer],[flxForm],flx-card,flx-accordion-item, [flxLayoutCollection], [flxLayoutCollectionPrototype], flx-modal, [flxTaskManagement]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxContainerStyleDirective {
  #component = inject(ComponentType, { self: true, optional: true })

  componentStyle = input<{
    style: ContainerStyles | CardStyles | FormStyles
    flowxProps?: TemplateConfigInterface['flowxProps']
    conditionalStyles: (ContainerStyles | CardStyles | FormStyles)[]
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyContainerCustomStyles(
        {
          styles: this.componentStyle().style,
          conditionalStyles: this.componentStyle().conditionalStyles,
        },
        theme(),
        fonts(),
        this.#component as
          | 'container'
          | 'card'
          | 'form'
          | 'modal'
          | 'collection'
          | 'collectionPrototype'
          | 'area'
          | 'page'
          | 'taskManagement',
        this.componentStyle().flowxProps?.hasAccordion
      )
      this.styleClassName.set(className)
    })
  }
}
